import { render } from "./PaymentResultView.vue?vue&type=template&id=9b46e918"
import script from "./PaymentResultView.vue?vue&type=script&lang=js"
export * from "./PaymentResultView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__